import { Injectable } from "@angular/core";
import { SERVER_API_URL } from "../app.constants";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ActivityRemarkService {
    private resourceUrl = SERVER_API_URL + 'api/activity-remarks';

    constructor(
        private http: HttpClient) {
    }

    createActivityRemark(keyAndRemark: ActivityRemarkKeyAndRemark): Observable<HttpResponse<boolean>> {
        return this.http.post<boolean>(`${this.resourceUrl}`, keyAndRemark, { observe: 'response' })
    }

    updateActivityRemark(keyAndRemark: ActivityRemarkKeyAndRemark): Observable<HttpResponse<boolean>> {
        return this.http.put<boolean>(`${this.resourceUrl}`, keyAndRemark, { observe: 'response' })
    }

    deleteActivityRemark(key: ActivityRemarkKey): Observable<HttpResponse<boolean>> {
        return this.http.delete<boolean>(`${this.resourceUrl}`, {
            observe: 'response', params:
            {
                'WorkplaceId': `${key.WorkplaceId}`,
                'PersonId': `${key.PersonId}`,
                'Year': `${key.Year}`,
                'Month': `${key.Month}`,
                'Day': `${key.Day}`
            }
        })
    }
}

export interface ActivityRemarkKey {
    WorkplaceId: number;
    PersonId: number;
    Year: number;
    Month: number;
    Day: number;
}

export interface ActivityRemarkKeyAndRemark {
    Key: ActivityRemarkKey;
    Remark: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/activity-remark.service.ts